<div class="faq">
  <div class="faq__banner">
    <h1 class="faq__title">Frequently Asked Questions</h1>
    <p class="faq__subtitle">Find answers to the most common questions about using HipTraveler, Premium Membership, Travelogging, bookings, and support.</p>
  </div>
  
  <div class="faq__content">
    <mat-accordion class="faq__main-accordion" multi="true">
      <mat-expansion-panel 
        *ngFor="let section of faqSections; let sectionIndex = index" 
        class="faq__section-panel"
        [expanded]="true">
        
        <mat-expansion-panel-header class="faq__section-header">
          <mat-panel-title class="faq__section-title">
            <mat-icon class="faq__section-icon">keyboard_arrow_down</mat-icon>
            {{ section.title }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        
        <div class="faq__section-content">
          <mat-accordion class="faq__nested-accordion">
            <mat-expansion-panel 
              *ngFor="let item of section.items; let itemIndex = index" 
              class="faq__item-panel"
              [expanded]="false">
              <mat-expansion-panel-header class="faq__item-header">
                <mat-panel-title class="faq__question">
                  {{ item.question }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="faq__answer">
                {{ item.answer }}
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  
  <app-support id="support"></app-support>
</div>

